module.exports = __webpack_public_path__ + "static/media/blog.20c1ae3e.svg";